export const INPROGRESS = "InProgress";
export const COMPLETED = "Completed";
export const DELETED = "Deleted";
